"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useScrollableContainerContext = exports.ScrollableContainerProvider = exports.ScrollableContainerContext = void 0;

var react_1 = __importDefault(require("react"));

exports.ScrollableContainerContext = react_1.default.createContext(undefined);

function ScrollableContainerProvider(_ref) {
  var targetRef = _ref.targetRef,
      children = _ref.children;
  return react_1.default.createElement(exports.ScrollableContainerContext.Provider, {
    value: {
      target: targetRef
    },
    children: children
  });
}

exports.ScrollableContainerProvider = ScrollableContainerProvider;

function useScrollableContainerContext(require) {
  var context = react_1.default.useContext(exports.ScrollableContainerContext);

  if (!context && require) {
    throw new Error('ScrollableContainerContext is required, yet not provided.');
  }

  return context;
}

exports.useScrollableContainerContext = useScrollableContainerContext;